module.exports = __webpack_public_path__ + "static/media/dec 2020.5370a58a.svg";